<template>
  <div>
    <certificates-new-filters-index
      v-if="filterExist"
      :filters="filters"
      type="registrations"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CertificatesNewFiltersIndex from "@/components/certificates/certificates-filters/certificates-filters-index.vue";
import { regFilters } from "@/plugins/mockups";

export default {
  components: {
    CertificatesNewFiltersIndex,
  },
  data() {
    return {
      viewportWidth: document.documentElement.clientWidth || document.body.clientWidth,
      filters: regFilters,
      showFilters: false,
      lengthOfSelectedFilters: 0,
      filterExist: false,
    };
  },
  computed: {
    ...mapGetters(["getRegistrations", "getRegistrationSearchParams"]),
  },
  methods: {
    ...mapActions(["updateRegistrationSearchParams", "updateRegistrations", "updateProcedures"]),
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
      // localStorage.setItem("showFiltersLocal", JSON.stringify(this.showFilters));
    },
  },
  async mounted() {
    try {
      const procedures = (await this.updateProcedures()).filter(p => p.protocol);

      const procFilter = this.filters.find(filter => filter.id === "procid");
      if (procFilter) {
        procFilter.items = procedures.map((procedure, index) => {
          return {
            title: procedure.name,
            selected: index === 0,
            id: procedure.procid,
          };
        });
        this.filterExist = true;
      }

      if (procedures.length === 0) {
        await this.updateRegistrations();
        this.$emit("actionResponse", {message: "No procedures available"})
        return;
      }

      if (procFilter) {
        procFilter.value = procedures[0].name;
      }

      await this.updateRegistrationSearchParams({
        ...this.getRegistrationSearchParams,
        procid: procedures[0].procid
      });

    } catch (err) {
      this.$emit("actionResponse", {message: err.response?.data?.msg || "Could not read registrations"})
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";

.v-sheet.v-card {
  box-shadow: none !important;
}
</style>
